<template>
  <div>
    <!-- main slider section state  -->
    <div id="carouselExample" class="carousel slide mobile-manu-top" data-bs-ride="carousel" data-bs-interval="3000">
      <!-- Indicators -->
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="0" class="active" aria-current="true"
          aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="2" aria-label="Slide 3"></button>
      </div>

      <div class="carousel-inner">
        <div v-for="slider in sliders" :key="slider.id" class="carousel-item active">
          <!-- Image and overlay -->
          <div class="carousel-image-container position-relative">
            <img :src="adminurl + 'fontend/slider/' + slider.image" class="d-block w-100" alt="Slide 1">
            <!-- Overlay -->
            <div class="carousel-overlay position-absolute top-0 start-0 w-100 h-100 bg-black opacity-50"></div>
          </div>

          <div id="CarouselCaption" class="carousel-caption d-none d-md-block">
            <h5 class="text-white fs-sm-1 fs-head ">{{ slider.headtitle }}</h5>
            <p class="slider-sub ">{{ slider.subtitle }}</p>
            <router-link to="/appointment" class="fs-2 mt-3 btn btn-thm  cs-slider-btn">{{ slider.link
              }}</router-link>
          </div>
        </div>
      </div>
      <!-- Controls -->
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
        <span class=" carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>

      <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
        <span class="  carousel-control-next-icon  " aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
    <!-- main slider section end  -->

    <!-- appoinment btn section state -->
    <div id="ApointmentGroupBtn" class="bg-apointment-group">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-3">
            <div class="bg-overlayer">
              <a :href="this.url + 'appointment'" class="d-flex align-items-center text-white costom-apointment">
                <i class="fa fa-inbox font-size-30 px-2"></i>
                Book Appointment
                <i class="fa fa-angle-right font-size-30 ps-4 "></i>
              </a>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-3">
            <div class="bg-overlayer ">
              <a :href="this.url + 'doctors'" class="d-flex align-items-center text-white costom-apointment">
                <i class="fa fa-address-book-o font-size-30 px-2"></i>
                Find Your Doctor
                <i class="fa fa-angle-right font-size-30 ps-5 "></i>
              </a>
            </div>
          </div>

          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="text-end background-images">
              <!-- <img src="images/logo/otline copy.png" alt=""> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- mobile section appointment state -->
    <div id="mobileApointment" class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="mobile-apoimtment-btn ">
            <div class="mobile-overly-bg py-5">
              <a><i class="mx-4 fa fa-inbox mobile-appoinment "></i>Book Appointment <i
                  class="mobile-appoint-icon-right me-5 pt-3 fa fa-angle-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="mobile-apoimtment-btn  ">
            <div class="mobile-overly-bg py-5">
              <a><i class="mx-4 fa fa-user mobile-appoinment "></i>Find Your Doctor<i
                  class="mobile-appoint-icon-right me-5 pt-3 fa fa-angle-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="mobile-apoimtment-btn  ">
            <div class="mobile-overly-bg py-5">
              <a><img class="w-100" src="images/logo/hotline copy.png" alt=""></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile section appointment state -->
    <!-- appoinment btn section end -->
    <!-- appoinment section state -->
    <div id="mr-hide" class="ulockd-appointment-form-one pb70 pt70">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="tretment-bg-img">
              <h3 class="prime-clg">Prime Medical College Hospital</h3>
              <h3 class="world-class text-dark">world </h3>
              <h3 class="world-class text-dark">CLASS</h3>
              <h3 class="tretment">treatment</h3>
              <h3 class="low-cost">At low cost<span class=""></span></h3>
              <div class="lowcost-border m-5"></div>
            </div>
          </div>

          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="row appointment_form_one mt60 box-booking">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <h2 class="text-thm">Book an Appointment</h2>
                <p>We Will Respond As Soon As Possible.</p>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-6">
                <div class="input-group mb-4">
                  <span class="input-group-text h-45  bg-blue">
                    <i class="fas fa-calendar-plus text-white fs-4"></i>
                  </span>
                  <select v-model="selectedSpecialty" class="selectforch form-control h-45 required ps-5" required=""
                    data-error="Selection is required.">
                    <option value=""> Select Department</option>
                    <option v-for="doctorInformation in doctorInformations" :key="doctorInformation.id"
                      :value="doctorInformation.id">{{ doctorInformation.title }}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-12 col-md-12 col-lg-6">
                <div class="input-group mb-4">
                  <span class="input-group-text h-45 bg-blue">
                    <i class="fas fa-stethoscope text-white fs-sm-1 fs-4"></i>
                  </span>
                  <select v-model="doctorId" class=" form-control selectforch h-45 required ps-5" required=""
                    data-error="Selection is required.">
                    <option value="">-- select Doctor --</option>
                    <option v-for="filteredDoctor in filteredDoctors" :value="filteredDoctor.id"
                      :key="filteredDoctor.id">{{ filteredDoctor.name }}</option>

                  </select>
                </div>
              </div>

              <div class="col-sm-12 col-md-12 col-lg-6">
                <div class="input-group">
                  <span class="input-group-text h-45 bg-blue fs-sm-1 fs-4">
                    <i class="fa fas fa-user text-white"></i>
                  </span>
                  <input v-model="name" type="text" class=" inputforch form-control" placeholder="Patient Name"
                    required>
                </div>
              </div>

              <div class="col-sm-12 col-md-12 col-lg-6">
                <div class="input-group">
                  <span class="input-group-text h-45 bg-blue fs-sm-1 fs-4">
                    <i class="fa fa-phone text-white"></i>
                  </span>
                  <input v-model="phone" type="text" class=" inputforch form-control" placeholder="Contact Number"
                    required>
                </div>
              </div>

              <div class="col-sm-6 col-md-12 col-lg-6">
                <div class="input-group">
                  <span class="input-group-text h-45 bg-blue fs-sm-1 fs-4">
                    <i class="fa fa-envelope text-white"></i>
                  </span>
                  <input v-model="email" type="email" class=" inputforch form-control"
                    placeholder="Email Address ( optional )">
                </div>
              </div>

              <!-- Phone Number Input -->
              <div class="col-sm-6 col-md-12 col-lg-6">
                <div class="input-group">
                  <span class="input-group-text h-45 bg-blue fs-sm-1 fs-4">
                    <i class="fa fa-calendar-o text-white"></i>
                  </span>
                  <input type="date" v-model="date" :class="{ 'is-invalid': errorMessage }" @change="showDateAlert"
                    class="inputforch form-control" placeholder="-- Select Date --">
                  <div v-if="errorMessage" class="invalid-feedback errormassages">
                    {{ errorMessage }}
                  </div>
                </div>
              </div>
              <a @click="saveAppointment" :disabled="loading"
                class="fs-sm-1 fs-md-1 py-3 btn btn-apt cs-slider-btn">Book Appointment</a>
              <!-- <p class="fs-5">Powered by <span><a class="text-info" href="">Nsm Limited</a></span></p> -->

            </div>
          </div>
        </div>
      </div>
      <!-- Full-screen Loading Overlay -->
      <div v-if="loading" class="loading-overlay">
        <div class="loader">
          <img src="/images/doctor/happy-nurses.gif" alt="">
        </div>
      </div>
    </div>
    <!-- appoinment section end -->
      
    <div id="mrDiagnosis" class="ulockd-appointment-form-one pb70 pt70">
      <div   class="container-fluid">
        <div class="row">
              <div class="col-sm-12">
                <div class="mr-head-title">
                  <h1 class="mr-btn-book">BOOK AN <br>APPOINMENT</h1>
                </div>
              </div>
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="row appointment_form_one mt60 box-booking">
              <div class="col-sm-12 col-md-12">
                <div class="input-group mb-4">
                  <span class="input-group-text h-45  bg-blue">
                    <i class="fas fa-calendar-plus text-white"></i>
                  </span>
                  <select v-model="selectedSpecialty" class="selectforch form-control h-45 required ps-5" required=""
                    data-error="Selection is required.">
                    <option value=""> Select Department</option>
                    <option v-for="doctorInformation in doctorInformations" :key="doctorInformation.id"
                      :value="doctorInformation.id">{{ doctorInformation.title }}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-12 col-md-12">
                <div class="input-group mb-4">
                  <span class="input-group-text h-45 bg-blue">
                    <i class="fas fa-stethoscope text-white"></i>
                  </span>
                  <select v-model="doctorId" class=" form-control selectforch h-45 required ps-5" required=""
                    data-error="Selection is required.">
                    <option value="">-- select Doctor --</option>
                    <option v-for="filteredDoctor in filteredDoctors" :value="filteredDoctor.id"
                      :key="filteredDoctor.id">{{ filteredDoctor.name }}</option>

                  </select>
                </div>
              </div>

              <div class="col-sm-12 col-md-12 ">
                <div class="input-group">
                  <span class="input-group-text h-45 bg-blue ">
                    <i class="fa fas fa-user text-white"></i>
                  </span>
                  <input v-model="name" type="text" class=" inputforch form-control" placeholder="Patient Name"
                    required>
                </div>
              </div>

              <div class="col-sm-12 col-md-12 ">
                <div class="input-group">
                  <span class="input-group-text h-45 bg-blue ">
                    <i class="fa fa-phone text-white"></i>
                  </span>
                  <input v-model="phone" type="text" class=" inputforch form-control" placeholder="Contact Number"
                    required>
                </div>
              </div>

              <div class="col-sm-12 col-md-12 ">
                <div class="input-group">
                  <span class="input-group-text h-45 bg-blue ">
                    <i class="fa fa-envelope text-white"></i>
                  </span>
                  <input v-model="email" type="email" class=" inputforch form-control"
                    placeholder="Email Address ( optional )">
                </div>
              </div>

              <!-- Phone Number Input -->
              <div class="col-sm-12 col-md-12">
                <div class="input-group">
                  <span class="input-group-text h-45 bg-blue ">
                    <i class="fa fa-calendar-o text-white"></i>
                  </span>
                  <input type="date" v-model="date" :class="{ 'is-invalid': errorMessage }" @change="showDateAlert"
                    class="inputforch form-control" placeholder="-- Select Date --">
                  <div v-if="errorMessage" class="invalid-feedback errormassages">
                    {{ errorMessage }}
                  </div>
                </div>
              </div>
              <a @click="saveAppointment" :disabled="loading"
                class="fs-sm-1 fs-md-1 py-3 btn btn-apt cs-slider-btn">Book Appointment</a>
              <!-- <p class="fs-5">Powered by <span><a class="text-info" href="">Nsm Limited</a></span></p> -->

            </div>
          </div>

          
        </div>
      </div>
      <!-- Full-screen Loading Overlay -->
      <div v-if="loading" class="loading-overlay">
        <div class="loader">
          <img src="/images/doctor/happy-nurses.gif" alt="">
        </div>
      </div>
    </div>

    <!-- our services state -->
    <div id="mr-hide" class="ulockd-servces-one pt70 pb70  bg-custom">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 offset-lg-3 text-center">
            <div class="main-title hvr-float-shadow">
              <h2 class="text-uppercase">Our <span class="text-thm">Services</span></h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xl-4">
            <router-link to="/Card-service">
              <div class="ulockd-srvcs-column text-center service-area">

                <div class="ulockd-srvcs-thumb">
                  <img class="img-fluid img-whp" src="images/services-page/i (1).webp" alt="">
                  <div class="ulockd-srvcs-overlay">
                    <div class="ulockd-srvcs-icon">
                      <a class="lightbox-image" data-fancybox-group="preject" :href="this.url + 'Card-service'">View
                        Details</a>
                    </div>
                  </div>
                </div>

                <div class="ulockd-srvc-contnt">
                  <h3 class="title"><a> Card Services</a></h3>
                  <p class="align-justify fs-sm-1 fs-md-1 h-93">Day in and day out Nursing and Medial Services gives
                    custom-made care to
                    individuals in their cabin who
                    are attempting to oversee.</p>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-sm-12 col-xl-4">
            <router-link to="/Cabin-service">
              <div class="ulockd-srvcs-column text-center  service-area">
                <div class="ulockd-srvcs-thumb">
                  <img class="img-fluid img-whp" src="images/services-page/i.webp" alt="">
                  <div class="ulockd-srvcs-overlay">
                    <div class="ulockd-srvcs-icon">
                      <a class="lightbox-image" data-fancybox-group="preject" :href="this.url + 'Cabin-service'">View
                        Details</a>
                    </div>
                  </div>
                </div>
                <div class="ulockd-srvc-contnt">
                  <h3 class="title"><a>Cabin Services</a></h3>
                  <p class="align-justify h-93">We trust that growth influences each individual in an unexpected way,
                    and
                    that each individual can
                    profit by an interesting, individualized care.</p>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-sm-12 col-xl-4">
            <router-link to="/Diagnostics">
              <div class="ulockd-srvcs-column text-center  service-area">
                <div class="ulockd-srvcs-thumb">
                  <img class="img-fluid img-whp" src="images/services-page/i (6).webp" alt="">
                  <div class="ulockd-srvcs-overlay">
                    <div class="ulockd-srvcs-icon">
                      <a class="lightbox-image" data-fancybox-group="preject" :href="this.url + 'Diagnostics'">View
                        Details</a>
                    </div>
                  </div>
                </div>
                <div class="ulockd-srvc-contnt">
                  <h3 class="title"><a>Diagnostic & Facilities</a></h3>
                  <p class="align-justify h-93">This level of care and supervision is for individuals who can't live
                    without anyone else's input yet
                    who needn't bother with 24 hour nursing care.</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- mobile service state -->
    <div id="servicesMobile" class="ulockd-servces-one pt70 pb70  bg-custom">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6 offset-lg-3 text-center">
            <div class="main-title hvr-float-shadow">
              <h2 class="text-uppercase">Our <span class="text-thm">Services</span></h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xl-4">
            <router-link to="/Card-service">
              <div class="ulockd-srvcs-column text-center service-area">

                <div class="ulockd-srvcs-thumb">
                  <img class="img-fluid img-whp" src="images/services-page/h_card_1 (1).jpg" alt="">
                  <div class="ulockd-srvcs-overlay">
                    <div class="ulockd-srvcs-icon">
                      <a class="lightbox-image" data-fancybox-group="preject" :href="this.url + 'Card-service'">View
                        Details</a>
                    </div>
                  </div>
                </div>

                <div class="ulockd-srvc-contnt">
                  <h3 class="title"><a> Card Services</a></h3>
                  <p class="align-justify fs-sm-1 fs-md-1 h-93">Day in and day out Nursing and Medial Services gives
                    custom-made care to
                    individuals in their cabin who
                    are attempting to oversee.</p>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-sm-12 col-xl-4">
            <router-link to="/Cabin-service">
              <div class="ulockd-srvcs-column text-center  service-area">
                <div class="ulockd-srvcs-thumb">
                  <img class="img-fluid img-whp" src="images/services-page/cabin_new.jpg" alt="">
                  <div class="ulockd-srvcs-overlay">
                    <div class="ulockd-srvcs-icon">
                      <a class="lightbox-image" data-fancybox-group="preject" :href="this.url + 'Cabin-service'">View
                        Details</a>
                    </div>
                  </div>
                </div>
                <div class="ulockd-srvc-contnt">
                  <h3 class="title"><a>Cabin Services</a></h3>
                  <p class="align-justify h-93">We trust that growth influences each individual in an unexpected way,
                    and
                    that each individual can
                    profit by an interesting, individualized care.</p>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-sm-12 col-xl-4">
            <router-link to="/Diagnostics">
              <div class="ulockd-srvcs-column text-center  service-area">
                <div class="ulockd-srvcs-thumb">
                  <img class="img-fluid img-whp" src="images/services-page/bio-6.jpg" alt="">
                  <div class="ulockd-srvcs-overlay">
                    <div class="ulockd-srvcs-icon">
                      <a class="lightbox-image" data-fancybox-group="preject" :href="this.url + 'Diagnostics'">View
                        Details</a>
                    </div>
                  </div>
                </div>
                <div class="ulockd-srvc-contnt">
                  <h3 class="title"><a>Diagnostic & Facilities</a></h3>
                  <p class="align-justify h-93">This level of care and supervision is for individuals who can't live
                    without anyone else's input yet
                    who needn't bother with 24 hour nursing care.</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
     <!-- mobile service end -->
    <!-- our services end -->

    <!-- our swiper slider section state -->
    <div class="my-5 swiper-container swiper mySwiper" ref="swiperContainer">
      <div class="row">
        <div class="col-lg-6 offset-lg-3 text-center">
          <div class="main-title hvr-float-shadow">
            <h2 class="text-uppercase">Our <span class="text-thm">Doctors</span></h2>
            <p class="text-dark mr-doctor">We have a large number of high qualified Doctors from reputed medical
              institutions of
              the world.</p>
          </div>
        </div>
      </div>
      <div class="swiper-wrapper">
        <div class="swiper-slide swiper-border col-12 col-sm-6 col-md-4 col-lg-3"
          v-for="(slide, index) in this.doctorSliders" :key="index">
          <img :src="this.adminurl + 'doctor/' + slide.image" :alt="slide.image" class="img-fluid" />
          <div class="swiper-text slide-content">
            <div class="btn-apt ">
              <h3><router-link :to="`/doctor-details/${slide.id}`" class="p-4 swiper-text  text-white btn-apt fs-2">{{
              slide.user.name }}</router-link></h3>
            </div>
            <p class="swiper-text">{{ slide.specialitys.title }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- our swiperslider  section end -->
    <!-- why Pmc state  -->
    <section id="mr-hide" class="ulockd-team-one">
      <div class="container">
        <div class="wrapper bgc-f7 p30 mb30">
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-srvc-contnt">
                <h4 class="text-info mr-why">Why PMC</h4>
                <h3 class="title"><a>Doctors Who Listen</a></h3>
                <p>Abolombon is first of kind health credit card by Prime Group. Teachers & Stuff from any govt
                  educational institute can avail the card with maximum 50,000 BDT credit facilities. Any private
                  institute under MPO is also eligible for the card.</p>
                <a :href="this.url + 'contactUs'" class=".btn-apt  fs-2 btn btn-thm cs-slider-btn">Contact us</a>
              </div>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-team-member mb30">
                <div class="ulockd-tm-thumb">
                  <img class="img-fluid img-whp" src="images/services-page/i (4).webp" alt="Service Image" />
                  <div class="ulockd-tm-overlay one text-start">
                    <div class="ulockd-tm-name">Doctors Who Listen</div>
                    <p>Abolombon is first of kind health credit card by Prime Group. Teachers & Stuff from any govt
                      educational institute can avail the card with maximum 50,000 BDT credit facilities. Any private
                      institute under MPO is also eligible for the card.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
 <!-- moile section state -->
 <section id="whymobileShow" class="ulockd-team-one">
      <div class="container-fluid">
        <div class="wrapper bgc-f7 p30 mb30">
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-srvc-contnt">
                <h4 class="text-info mr-why">Why PMC</h4>
                <h3 class="title"><a>Doctors Who Listen</a></h3>
                <p>Abolombon is first of kind health credit card by Prime Group. Teachers & Stuff from any govt
                  educational institute can avail the card with maximum 50,000 BDT credit facilities. Any private
                  institute under MPO is also eligible for the card.</p>
                <a :href="this.url + 'contactUs'" class=".btn-apt  fs-2 btn btn-thm cs-slider-btn">Contact us</a>
              </div>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-team-member mb30">
                <div class="ulockd-tm-thumb">
                  <img class="img-fluid img-whp" src="images/services-page/i (4).webp" alt="Service Image" />
                  <div class="ulockd-tm-overlay one text-start">
                    <div class="ulockd-tm-name">Doctors Who Listen</div>
                    <p>Abolombon is first of kind health credit card by Prime Group. Teachers & Stuff from any govt
                      educational institute can avail the card with maximum 50,000 BDT credit facilities. Any private
                      institute under MPO is also eligible for the card.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
 <!-- moile section state -->

    <section id="mr-hide" class="ulockd-team-one">
      <div class="container">
        <div class="wrapper bgc-f7 p30 mb30">
          <div class="row">
            <div id="mrDiagnosis" class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-srvc-contnt  bg-blue">
                <h3 class="title"><a class="text-white">Diagnosis You Can Trust</a></h3>
                <p class="text-white">You can depend on the quality of our diagnosis and test results. Our laboratories
                  are set up according to international standards and protocols and Praava's diagnostic lab is one of
                  six internationally accredited labs in Bangladesh.</p>
                <!-- <a href="#" class="fs-2 btn btn-thm cs-slider-btn">Contact us</a> -->
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-team-member mb30">
                <div class="ulockd-tm-thumb">
                  <img class="img-fluid img-whp" src="images/services-page/i (2).webp" alt="Service Image" />
                  <div class="ulockd-tm-overlay one text-start">

                    <div class="ulockd-tm-name">Diagnosis You Can Trust</div>
                    <p>You can depend on the quality of our diagnosis and test results. Our laboratories are set up
                      according to international standards and protocols and Praava's diagnostic lab is one of six
                      internationally accredited labs in Bangladesh.</p>
                  </div>
                </div>
              </div>
            </div>
            <div id="whytitle" class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-srvc-contnt  bg-blue">
                <h3 class="title"><a class="text-white">Diagnosis You Can Trust</a></h3>
                <p class="text-white">You can depend on the quality of our diagnosis and test results. Our laboratories
                  are set up according to international standards and protocols and Praava's diagnostic lab is one of
                  six internationally accredited labs in Bangladesh.</p>
                <!-- <a href="#" class="fs-2 btn btn-thm cs-slider-btn">Contact us</a> -->
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
    <!-- mobile section state  -->
    <section id="whymobileShow" class="ulockd-team-one">
      <div class="container-fluid">
        <div class="wrapper bgc-f7 p30 mb30">
          <div class="row">
            <div id="mrDiagnosis" class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-srvc-contnt  bg-blue">
                <h3 class="title"><a class="text-white">Diagnosis You Can Trust</a></h3>
                <p class="text-white">You can depend on the quality of our diagnosis and test results. Our laboratories
                  are set up according to international standards and protocols and Praava's diagnostic lab is one of
                  six internationally accredited labs in Bangladesh.</p>
                <!-- <a href="#" class="fs-2 btn btn-thm cs-slider-btn">Contact us</a> -->
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-team-member mb30">
                <div class="ulockd-tm-thumb">
                  <img class="img-fluid img-whp" src="images/services-page/i (2).webp" alt="Service Image" />
                  <div class="ulockd-tm-overlay one text-start">

                    <div class="ulockd-tm-name">Diagnosis You Can Trust</div>
                    <p>You can depend on the quality of our diagnosis and test results. Our laboratories are set up
                      according to international standards and protocols and Praava's diagnostic lab is one of six
                      internationally accredited labs in Bangladesh.</p>
                  </div>
                </div>
              </div>
            </div>
            <div id="whytitle" class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-srvc-contnt  bg-blue">
                <h3 class="title"><a class="text-white">Diagnosis You Can Trust</a></h3>
                <p class="text-white">You can depend on the quality of our diagnosis and test results. Our laboratories
                  are set up according to international standards and protocols and Praava's diagnostic lab is one of
                  six internationally accredited labs in Bangladesh.</p>
                <!-- <a href="#" class="fs-2 btn btn-thm cs-slider-btn">Contact us</a> -->
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
    <!-- mobile section state  -->

    <section id="mr-hide" class="ulockd-team-one">
      <div class="container">
        <div class="wrapper bgc-f7 p30 mb30">
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-srvc-contnt bg-blue">
                <h3 class="title"><a class="text-white">Healthcare Anytime, Anywhere</a></h3>
                <p class="text-white">We use technology to make healthcare accessible to you no matter where you are.
                  You can access your health data, book appointments, review your prescriptions, and view your medical
                  records, anywhere at your convenience.</p>
              </div>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-team-member mb30">
                <div class="ulockd-tm-thumb">
                  <img class="img-fluid img-whp" src="images/services-page/i (3).webp" alt="Service Image" />
                  <div class="ulockd-tm-overlay one text-start">
                    <div class="ulockd-tm-name">Healthcare Anytime, Anywhere</div>
                    <p>We use technology to make healthcare accessible to you no matter where you are. You can access
                      your health data, book appointments, review your prescriptions, and view your medical records,
                      anywhere at your convenience.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>

    <!-- mobile version state section  -->
    <section id="whymobileShow" class="ulockd-team-one">
      <div class="container-fluid">
        <div class="wrapper bgc-f7 p30 mb30">
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-srvc-contnt bg-blue">
                <h3 class="title"><a class="text-white">Healthcare Anytime, Anywhere</a></h3>
                <p class="text-white">We use technology to make healthcare accessible to you no matter where you are.
                  You can access your health data, book appointments, review your prescriptions, and view your medical
                  records, anywhere at your convenience.</p>
              </div>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-6">
              <div class="ulockd-team-member mb30">
                <div class="ulockd-tm-thumb">
                  <img class="img-fluid img-whp" src="images/services-page/i (3).webp" alt="Service Image" />
                  <div class="ulockd-tm-overlay one text-start">
                    <div class="ulockd-tm-name">Healthcare Anytime, Anywhere</div>
                    <p>We use technology to make healthcare accessible to you no matter where you are. You can access
                      your health data, book appointments, review your prescriptions, and view your medical records,
                      anywhere at your convenience.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
    <!-- mobile version state section  -->
    <!-- why Pmc end  -->
    <!-- appointment  Divider state -->
    <div class="bg-black padding-top-buttom">
      <div class="adjustable-container container">
        <div class="row">
          <div class="col-sm-9 col-md-7 col-lg-9">
            <div class="text-center text-md-start mb20-sm">
              <h2 class="ulockd-dvidr-mttl">We Offer Quality Full and Affordable Service For You.</h2>
            </div>
          </div>
          <div class="col-sm-3 col-md-5 col-lg-3">
            <div class="ulockd-dvidr-btn text-uppercase text-center text-md-end mt0">
              <router-link to="/doctors" class=".btn-apt btn btn-default btn-white hvr-overline-from-center"
                href="#">Get
                Appointment</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  appointment  Divider end -->
    <!-- our expart section state -->
    <section id="mr-hide" class="pt70 pb70">
      <div class="container">
        <div class="row">
          <div class=" col-md-12 col-lg-6 offset-lg-3 text-center">
            <div class="main-title hvr-float-shadow">
              <h2 class="text-uppercase">Our Management <span class="text-thm">Team</span></h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-for="management in managements" :key="management.id" class="col-sm-12 col-md-12 col-lg-3">
            <div class="ulockd-team-two-member">
              <div class="ulockd-tm-thumb">
                <!-- Dynamically bind the image source -->
                <img class="img-fluid img-whp" :src="adminurl + 'fontend/management/' + management.image"
                  alt="Management Image">


                <div class="ulockd-team-two-mdetails">
                  <!-- Display dynamic name and designation -->
                  <div class="ulockd-tm-name">{{ management.name }}</div>
                  <div class="Welcome-description ulockd-tm-post">{{ management.designation }}</div>

                  <!-- Dynamic social links -->
                  <ul class="ulockd-tm-sicon bgc-thm">
                    <li class="list-inline-item">
                      <a :href="management['facebook_link']" target="_blank"><i class="fab fa-facebook-f"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <a :href="management['gmail_link']" target="_blank"><i class="fab fa-google"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <a :href="management['linkedin_link']" target="_blank"><i class="fab fa-linkedin"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <a :href="management['whatsapp_link']" target="_blank"><i class="fa fa-envelope"></i></a>
                    </li>
                  </ul>

                  <!-- Display dynamic contact details -->
                  <ul class="list-unstyled ulockd-tm-fpm bgc-thm">
                    <li v-if="management.fax" target="_blank">Fax: {{ management.fax }}</li>
                    <li><a class="text-white" href="tel:{{ management.phone }}" target="_blank">Phone: {{
                      management.phone
                        }}</a></li>
                    <li><a class="text-white" :href="management.gmail_link" target="_blank">mailto : {{
                      management.gmail_link }}</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- mobile varsion manegment state  -->
    <section id="whymobileShow" class="pt70 pb70">
      <div class="container-fluid">
        <div class="row">
          <div class=" col-md-12 col-lg-6 offset-lg-3 text-center">
            <div class="main-title hvr-float-shadow">
              <h2 class="text-uppercase">Our Management <span class="text-thm">Team</span></h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-for="management in managements" :key="management.id" class="col-sm-12 col-md-12 col-lg-3">
            <div class="ulockd-team-two-member">
              <div class="ulockd-tm-thumb">
                <!-- Dynamically bind the image source -->
                <img class="img-fluid img-whp" :src="adminurl + 'fontend/management/' + management.image"
                  alt="Management Image">


                <div class="ulockd-team-two-mdetails">
                  <!-- Display dynamic name and designation -->
                  <div class="ulockd-tm-name">{{ management.name }}</div>
                  <div class="Welcome-description ulockd-tm-post">{{ management.designation }}</div>

                  <!-- Dynamic social links -->
                  <ul class="ulockd-tm-sicon bgc-thm">
                    <li class="list-inline-item">
                      <a :href="management['facebook_link']" target="_blank"><i class="fab fa-facebook-f"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <a :href="management['gmail_link']" target="_blank"><i class="fab fa-google"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <a :href="management['linkedin_link']" target="_blank"><i class="fab fa-linkedin"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <a :href="management['whatsapp_link']" target="_blank"><i class="fa fa-envelope"></i></a>
                    </li>
                  </ul>

                  <!-- Display dynamic contact details -->
                  <ul class="list-unstyled ulockd-tm-fpm bgc-thm">
                    <li v-if="management.fax" target="_blank">Fax: {{ management.fax }}</li>
                    <li><a class="text-white" href="tel:{{ management.phone }}" target="_blank">Phone: {{
                      management.phone
                        }}</a></li>
                    <li><a class="text-white" :href="management.gmail_link" target="_blank">mailto : {{
                      management.gmail_link }}</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- mobile varsion manegment end  -->
    <!-- our expart section end -->
    <!-- photo album end -->
    <section :style="{
      backgroundColor: 'red',
      backgroundAttachment: 'fixed',
      backgroundImage: `url('./images/featureImg/5 (3).jpg')`,
      backgroundPosition: 'center center'
    }" class="ulockd-service-three bg-gallery-img pb70">
      <div class="adjustable-container container">
        <div class="row">
          <div class="col-lg-6 offset-lg-3 text-center">
            <div class="main-title hvr-float-shadow">
              <h2 class="text-uppercase">Our Photo <span class="text-thm"> Album</span></h2>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="masonry-isotop">
              <!-- Masonry Filter -->
              <ul class="masonry-filter text-center">
                <button class="active-all text-white btn btn-default btn-white filter-button me-2 border"
                  data-filter="all">All</button>
                <button class="btn btn-default btn-white  filter-button me-2 border" data-filter="1">Hub</button>
                <button class="btn btn-default btn-white filter-button me-2 border" data-filter="2">Corporate</button>
                <button class="btn btn-default btn-white filter-button me-2 border" data-filter="3">Pharmacy</button>
                <button class="btn btn-default btn-white filter-button me-2 border"
                  data-filter="4">Consultation</button>
              </ul>
              <!-- End Masonry Filter -->
              <!-- Masonry Grid -->
              <!-- hub images -->
              <div class="row">
                <!-- corporate images state -->
                <div v-for="galleryImage in galleryImages" :key="galleryImage.id"
                  :class="'col-12 col-sm-12 col-md-6 col-lg-3 gallery-item mb-3 ' + galleryImage.category_id">
                  <div class="gallery-image position-relative">
                    <img :src="this.adminurl + 'fontend/Galleryimage/' + galleryImage.image"
                      class="img-fluid hvr-float-shadow">
                    <div class="overlay align-items-center justify-content-center">
                      <p class="d-block mt-5 text-white fw-bold">Our Gallery Title</p>
                      <div class="text-center">
                        <i class="fa fa-picture-o rounded-circle p-3 border me-2"></i>
                        <i class="fa fa-link p-3 rounded-circle border"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- corporate images state -->
              </div>
              <!-- Masonry Gallery Grid Item -->
            </div>
          </div>
        </div>

      </div>
    </section>
    <!-- photo album end -->
    <!-- mobile gallery photo slider  -->
     <div id="carouselExampleAutoplaying"  class="container-fluid">
    <div class="row">
          <div class="col-lg-6 offset-lg-3 text-center">
            <div class="main-title hvr-float-shadow">
              <h2 class="text-uppercase">Our Photo <span class="text-thm">Gallery</span></h2>
            </div>
          </div>
        </div>
    <div class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div v-for="(galleryImage, index) in galleryImages" :key="galleryImage.id"
          :class="['carousel-item', { active: index == 0 }]">
          <img :src="this.adminurl + 'fontend/Galleryimage/' + galleryImage.image" class="d-block w-100" alt="...">
        </div>
      </div>

      <!-- mobile gallery photo slider-->
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true">
          <i class="fas fa-chevron-left"></i> <!-- FontAwesome icon for left arrow -->
        </span>
        <span class="visually-hidden">Previous</span>
      </button>

      <!-- Next Button with custom icon -->
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true">
          <i class="fas fa-chevron-right"></i> <!-- FontAwesome icon for right arrow -->
        </span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>


    <!-- gallery photo slider mobile  -->

  </div>
</template>
<script>

import { onMounted, ref, computed } from "vue";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import { useStore } from 'vuex';
import Swal from "sweetalert2";
import axios from 'axios';

export default {
  name: "SwiperSlider",
  computed: {
    adminurl() {
      return this.$store.state.adminurl;

    },
    url() {
      return this.$store.state.url;
    },
    // Filter doctors based on the selected specialty ID
    filteredDoctors() {
      if (!this.selectedSpecialty) return [];
      const selectedSpecialty = this.doctorInformations.find(
        specialties => specialties.id == this.selectedSpecialty
      );
      return selectedSpecialty ? selectedSpecialty.doctor : [];
    },

    isFormValid() {
      return !this.errorMessage;
    },
  },

  mounted() {
    var swiper = new Swiper(".mySwiper", {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 50,
        },
      },
    });
  },
  setup() {
    const swiperContainer = ref(null);
    const doctorSliders = ref([]);
    const store = useStore();
    const adminurl = computed(() => store.state.adminurl);

    const fetchSlides = async () => {
      try {
        const response = await axios.get(adminurl.value + 'api/doctorSlider');
        if (response.data && Array.isArray(response.data)) {
          doctorSliders.value = response.data; // Update the slides array with the API response
        }
      } catch (error) {
        console.error('Error fetching slides data:', error);
      }
    };

    onMounted(() => {
      new Swiper(swiperContainer.value, {
        slidesPerView: 4,
        spaceBetween: 20,
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: true,
        grabCursor: true,
      });
      fetchSlides();
    });

    return { swiperContainer, doctorSliders };
  },
  data() {
    return {
      loading: false,
      sliders: [],
      sliderimages: [],
      managements: [],
      doctorInformations: [],
      galleryImages: [],
      selectedSpecialty: "",
      date: "",
      doctorId: "",
      name: "",
      phone: "",
      email: "",
      errorMessage: "",
    };
  },

  created() {
    // Make an AJAX call to the Laravel API Main Slider
    axios.get(this.adminurl + 'api/slider')
      .then(response => {
        this.sliders = response.data;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
    // Make an AJAX call to the Laravel API Our Management Team
    axios.get(this.adminurl + 'api/management')
      .then(response => {
        this.managements = response.data.managements;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
    // Make an AJAX call to the Laravel input Appointment
    axios.get(this.adminurl + 'api/doctor-information')
      .then(response => {
        console.log(response.data);
        this.doctorInformations = response.data.specialties;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });

    // gallery api state
    axios.get(this.adminurl + 'api/galleryImageall')
      .then(response => {
        this.galleryImages = response.data;
        console.log(this.galleryImages);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  },

  methods: {
    limitDescription(description) {
      const words = description.split(' ');
      return words.slice(0, 20).join(' ') + (words.length > 20 ? '...' : '');
    },
    serviceDescription(description) {
      const words = description.split(' ');
      return words.slice(0, 20).join(' ') + (words.length > 20 ? '...' : '');
    },
    showDateAlert() {
      const currentDate = new Date().toISOString().split('T')[0];
      if (this.date && this.date < currentDate) {
        this.date = '';
        this.errorMessage = 'The date is not allowed!';
      } else {
        this.errorMessage = '';
        axios.get(this.adminurl + 'api/count-appointment', {
          params: {
            doctorId: this.doctorId,
            date: this.date
          }
        }).then(response => {
          console.log(response.data);
          if (response.data.status == false) {
            this.date = '';
            this.errorMessage = response.data.error;
          }
        }).catch(error => {
          console.error("There was an error with the date request:", error);
        });
      }
    },

    saveAppointment() {
      this.loading = true;
      if (!this.selectedSpecialty || !this.doctorId || !this.date) {
        this.errorMessage = 'All fields are required!';
        return;
      }
      axios.post(this.adminurl + 'api/save-appointment', {
        speciality_id: this.selectedSpecialty,
        doctor_id: this.doctorId,
        date: this.date,
        name: this.name,
        phone: this.phone,
        email: this.email,
      })
        .then(response => {
          console.log(response.data);
          this.errors = { name: '', phone: '' };
          this.selectedSpecialty = '';
          this.doctorId = '';
          this.date = '';
          this.name = '';
          this.phone = '';
          this.email = '',
            this.errorMessage = '';
          this.loading = false;
          Swal.fire({
            title: "Appointment Booked!",
            text: "Your appointment has been successfully scheduled.",
            icon: "success",
            confirmButtonText: "OK"
          });

        })
        .catch((error) => {
          this.loading = false;
          console.error('Error saving appointment:', error);
          this.errorMessage = 'There was an error saving the appointment.';

        });
    },


  }
};
// Filter functionality
$(document).ready(function () {
  $(".filter-button").click(function () {
    var filter = $(this).data("filter");
    if (filter == "all") {
      $(".gallery-item").show();
    } else {
      $(".gallery-item").hide();
      $("." + filter).show();
    }
  });
});

</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* Black background with opacity */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Loader (spinner) style */
.loader {
  width: 100px;
  height: 100px;
  border: 8px solid #f3f3f3;
  /* border-top: 8px solid #3498db; */
  border-radius: 50%;
  /* animation: spin-9ea40744 1s linear infinite; */
}

.loader img {
  border-radius: 30px;
}

/* Spinner animation */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}






.carousel-item .col-6 {
  display: flex;
  justify-content: center;
}

.cd-full-width {
  width: 40%;
  margin: 0 auto;
}

.fs-19 {
  font-weight: 700;
  font-size: 19px;
}

.fs-15 {
  font-size: 15px;
}

.text-left {
  text-align: left;
}

.mb-7 {
  margin-bottom: 68px;
}

.h-600 {
  height: 600px;
}


.gallery-item {
  position: relative;
  overflow: hidden;
}

.gallery-item img {
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.masonry-isotop .row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.gallery-item {
  flex: 0 0 23%;
  /* Adjust the width to fit 4 items per row */
  margin-bottom: 15px;
}

@media (max-width: 767px) {
  .gallery-item {
    flex: 0 0 48%;
    /* Adjust for smaller screen (2 items per row) */
  }
}

@media (max-width: 575px) {
  .gallery-item {
    flex: 0 0 100%;
    /* Full width on very small screens */
  }
}

.gallery-image {
  position: relative;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  color: white;
  visibility: hidden;
  /* Hide overlay by default */
  opacity: 0;
  transition: opacity 0.3s ease, visibility 0s 0.3s;
  text-align: center;
  padding: 15px;
}

.gallery-image:hover .overlay {
  visibility: visible;
  background: #3b6997;
  display: table-cell;
  opacity: 0.70;
  transition: opacity 0.3s ease;
}

.active-all {
  background: #008c42;
}

.Welcome-description {
  font-size: 16px;
  padding: 1px;
}

.form-control option.disable {
  color: #6c757d;
  /* Placeholder color */
}

.form-control:invalid {
  color: #6c757d;
  /* Match placeholder color */
}

.form-control:valid {
  color: #212529;
  /* Normal text color */
}


.fs-44 {
  font-size: 44px;
}

.fw-200 {
  font-weight: 200;
}

.bg-about-se {
  background-color: darkgreen;
}

.padding-top-buttom {
  padding-top: 50px;
  padding-bottom: 40px;
}


.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgb(0 0 0 / 71%) !important;
}

.custom-caption {
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent black */
  padding: 20px;
  /* Add some padding for better spacing */
  border-radius: 8px;
  /* Optional: rounded corners */
}

.h-170 {
  height: 170px !important;
}

.h-195 {
  height: 195px;
}

.h-116 {
  font-size: 16px;
  height: 126px;
}

.fs-head {
  color: #fff;
  font-size: 67px;
  font-size: calc(40px + .05vw);
  font-weight: 600;
  letter-spacing: -.009em;
  line-height: 1.3;
  text-transform: capitalize;
}

.slider-sub {
  font-size: calc(22px + .05vw);
  line-height: 1.25;
}

.carousel-image-container {
  position: relative;
}

.slider-sub {
  color: #e0e0e1;
  font-family: Proxima Nova, sans-serif;
  font-weight: 400;
  font-size: calc(22px + .05vw);
  line-height: 1.25;
}

.cs-slider-btn {
  text-transform: none;
  font-family: inherit;
}

.serchber-home {

  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.5);

}

.bg-overlayer {
  background-color: #3FAD4E;
  opacity: 0.83;
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.bg-blue {
  background-color: #008c42;
}

.box-booking {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2), 0 -10px 20px rgba(0, 0, 0, 0.1);
}

.h-45 {
  height: 45px;
}

.btn-apt {
  font-weight: 400;
  background-color: #003872;
  color: #ffffff;
}

.btn-apt:hover {
  background-color: #0b2744;
}

.prime-clg {
  color: #089928;
}

.world-class {
  color: #000000;
  font-family: "Exo", sans-serif;
  font-size: 64px;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 70px;

}

.tretment {
  color: #1A66B1;
  font-family: "Exo", sans-serif;
  font-size: 64px;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 70px;
}

.low-cost {
  color: #222222;
  margin: 7px 0px 0px 0px;
  font-family: "Exo", sans-serif;
  font-size: 36px;
  font-weight: 700;
  line-height: 48px;
}

.lowcost-border {
  width: 50px;
  height: 3px;
  background-color: #1cba9f;
}

.align-justify {
  padding: 0px 18px;
  text-align: justify !important;
}

.selectforch:focus {
  border-color: #007bff;
  box-shadow: 0 0 8px rgba(0, 123, 255, 0.5);
}

.inputforch:focus {
  border-color: #007bff;
  box-shadow: 0 0 8px rgba(0, 123, 255, 0.5);
}

.h-93 {
  height: 95px !important;
}

.errormassages {
  margin-left: 31px !important;
  margin-top: -1.75rem !important;
  font-size: .875em !important;
}
</style>
